import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import swal from 'sweetalert';
import 'react-dropdown-tree-select/dist/styles.css'


class CreateLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: ""
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem('location_info') == null) {
            window.location.href = "/create/listsop"
        } else {
            var propsJson = JSON.parse(sessionStorage.getItem('location_info'));
            if (propsJson.operation_type === "edit") {
                this.setState({ name: propsJson.location_name, id: propsJson.id, operation_type: "edit" });
            } else {
                this.setState({ operation_type: "create" });
            }
        }
    }

    onChangeInput = (e) => {
        e.preventDefault();

        this.setState({ [e.target.name]: e.target.value })
    }


    submit = (e) => {
        if (this.state.operation_type === "create") {
            this.create();
        }
        else if (this.state.operation_type === "edit") {
            this.edit()
        } else {
            window.location.href = "/create/listlocation"
        }

    }
    edit = () => {
        var data = {
            location_id: this.state.id,
            location_name: this.state.name,
            status: 1
        };
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/location/update`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        window.location.href = "/create/listlocation"
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.edit();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    create = () => {
        var data = {
            location_name: this.state.name
        };
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/location/add`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        window.location.href = "/create/listlocation"
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.create();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }


    render() {

        const { errors } = this.state;
        return (
            <div>
                <div className="xp-breadcrumbbar">
                    <div className="row">

                        <div className="col-md-6 col-lg-6">
                            <h4 class="xp-page-title">{this.state.operation_type == "create" ? "Create Location" : "Edit Location"} </h4>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/listlocation"}>Location List</a></li>
                                </ol>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar p-30">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card m-b-30">
                                <div className="card-header bg-primary">
                                    <h5 className="card-title text-white">{this.state.operation_type == "create" ? "Create Location" : "Edit Location"}</h5>
                                </div>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="form-group col-md-12">
                                            <label for="exampleInputEmail1">Location Name</label>
                                            <input type="text" onChange={this.onChangeInput} value={this.state.name} name="name" className="form-control" placeholder="Enter Location Name" />
                                        </div>

                                    </div>

                                    <button onClick={this.submit} className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CreateLocation

